import '../core-js.js';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getGlobalParam } from '@agilemd/ui-utils';

import store from '../data/store.js';
import Banner from './Banner.jsx';
import Shell from './components/Shell/index.js';
import '../../scss/surpas.scss';

const metaContainer = globalThis.document.querySelector('.surpas-meta');

if (metaContainer) {
  createRoot(metaContainer).render(
    <Banner
      isPublic={getGlobalParam('isPublic')}
      backUrl={getGlobalParam('backUrl')}
      baseUrl={getGlobalParam('baseUrl')}
      feedbackCategories={getGlobalParam('feedbackCategories')}
      feedbackPrompt={getGlobalParam('feedbackPrompt')}
      iconUrl={getGlobalParam('iconUrl')}
      subtitle={getGlobalParam('subtitle')}
      title={getGlobalParam('title')}
    />
  );
}

const appEl = globalThis.document.querySelector('.surpas-application');

if (appEl) {
  createRoot(appEl).render(
    <Provider store={store}>
      <Shell
        offsets={{
          left: parseInt(appEl.offsetLeft, 10),
          top: parseInt(appEl.offsetTop, 10)
        }}
      />
    </Provider>
  );
}
